<template>
    <div>
        <div class="product_menu">
            <dl class="pageCenter" id="product_menu">
                <dt><a href="#page1" title="唐麦耳机B0">Tangmai B0</a></dt>
                <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                <dd data-menuanchor="page5"><a href="#page5">外观</a></dd>
                <dd data-menuanchor="page6"><a href="#page6">品质</a></dd>
                <dd data-menuanchor="page7"><a href="#page7">线材</a></dd>
                <dd data-menuanchor="page8"><a href="#page8">体验</a></dd>
                <dd data-menuanchor="page9"><a href="#page9">参数</a></dd>
            </dl>
        </div>
        <div id="product" style="z-index:1;" v-if="platform == 1">
            <!-- 头部 -->
            <div class="section header active fp-auto-height">
                <v-header></v-header>

                <div class="product_menu2">
                    <dl class="pageCenter">
                        <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                        <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                        <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                        <dd data-menuanchor="page5"><a href="#page5">外观</a></dd>
                        <dd data-menuanchor="page6"><a href="#page6">品质</a></dd>
                        <dd data-menuanchor="page7"><a href="#page7">线材</a></dd>
                        <dd data-menuanchor="page8"><a href="#page8">体验</a></dd>
                        <dd data-menuanchor="page9"><a href="#page9">参数</a></dd>
                    </dl>
                </div>
            </div>

            <div class="section product_li" style=" background:url(http://wx3.sinaimg.cn/large/0067mezugy1foqj1fot0rj31hc0kudy0.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -75px;"><img src="../../assets/img/b0/1.png" height="130" style="margin-left: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx1.sinaimg.cn/large/0067mezugy1foqj1ghn4jj31hc0kunj1.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 18%"><img src="../../assets/img/b0/2.png" height="80" style="margin-right: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx3.sinaimg.cn/large/0067mezugy1foqj1h9tdzj31hc0ku4lx.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 12%"><img src="../../assets/img/b0/3.png" height="80" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx3.sinaimg.cn/large/0067mezugy1foqj1i5jobj31hc0kunjs.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="../../assets/img/b0/4.png" height="80" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx1.sinaimg.cn/large/0067mezugy1foqj1j78lxj31hc0kux4b.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 18%"><img src="../../assets/img/b0/5.png" height="80" style="margin-right: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx1.sinaimg.cn/large/0067mezugy1foqj1jsqn0j31hc0kuq8d.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -75px;"><img src="../../assets/img/b0/6.png" height="130" style="margin-left: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1foqj1kcgiwj31hc0kun4c.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 12%"><img src="../../assets/img/b0/7.png" height="80" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx4.sinaimg.cn/large/0067mezugy1fosoateo3wj31hc0kuq3s.jpg) center; background-size:auto 100%;">
            <div class="pageCenter">
            	<p style=" top:20%; text-align:left; width:100%;"><img src="../../assets/img/b0/8.png" height="66" /></p>
				<div class="product_data">
                	<ul>
                    	<li class="left">
                        	<div class="data_box"><p class="data_p1">产品型号</p>
                        	<p class="data_p2">Product number</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">B0</p>
                            <p class="data_p2">B0</p>
                            </div>
                        </li>
                        <li>
                        	<div class="data_box"><p class="data_p1">蓝牙版本</p>
                        	<p class="data_p2">Bluetooth version</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">V4.2</p>
                            <p class="data_p2">V4.2</p>
                            </div>
                        </li>
                        <li class="left">
                        	<div class="data_box"><p class="data_p1">工作距离</p>
                        	<p class="data_p2">Working distance</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">约10m</p>
                            <p class="data_p2">About 10m</p>
                            </div>
                        </li>
                        <li>
                        	<div class="data_box"><p class="data_p1">频响范围</p>
                        	<p class="data_p2">Frequency Range</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">20Hz-20KHz</p>
                            <p class="data_p2">20Hz-20KHz</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">喇叭阻抗</p>
                        	<p class="data_p2">Speaker impedance</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">4Ω</p>
                            <p class="data_p2">4Ω</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">产品净重</p>
                        	<p class="data_p2">Product Weight</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">218g</p>
                            <p class="data_p2">218g</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">输入电压</p>
                        	<p class="data_p2">Input voltage</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">DC=5V/1- 2A</p>
                            <p class="data_p2">DC=5V/1- 2A</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">充电时间</p>
                        	<p class="data_p2">Charging time</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">约2.5小时</p>
                            <p class="data_p2">About 2.5 hours</p>
                            </div>
                        </li>
                    </ul>
                </div>
				
            </div>
        </div>

            <!-- 尾部 -->
            <div class="section fp-auto-height fp-section">
                <v-footer></v-footer>
            </div>
            
        </div>

        <div id="mobile" v-else>
            <!--手机端头部-->
            <v-header></v-header>
            <div class="mobile_pageMain">
                <div class="tools">
                    <span class="span1">产品</span>
                    <span class="span2">唐麦 B0</span>
                </div>
                <img class="productImg" style="margin-top:40px;" src="http://wx3.sinaimg.cn/large/0067mezugy1fosnoqwzrhj30u00xck5y.jpg" />
                <img class="productImg" src="http://wx4.sinaimg.cn/large/0067mezugy1fosnp4t88jj30u00xc1kx.jpg" />
                <img class="productImg" src="http://wx3.sinaimg.cn/large/0067mezugy1fosnpemf34j30u00xcdxw.jpg" />
                <img class="productImg" src="http://wx1.sinaimg.cn/large/0067mezugy1fosnpq5131j30u00xc4ks.jpg" />
                <img class="productImg" src="http://wx3.sinaimg.cn/large/0067mezugy1fosnq2j4uuj30u00xcnkz.jpg" />
                <img class="productImg" src="http://wx1.sinaimg.cn/large/0067mezugy1fosnqh4i8tj30u00xc7c9.jpg" />
                <img class="productImg" src="http://wx4.sinaimg.cn/large/0067mezugy1fosnqn7pnxj30u00xcqcd.jpg" />
                <img class="productImg" src="http://wx1.sinaimg.cn/large/0067mezugy1fosnqquda1j30u00xc77l.jpg" />
            </div>
            <v-footer></v-footer>
        </div>
        <!-- 回到顶部 -->
        <a href="#page1"><goto-top></goto-top></a>
    </div>
</template>
<script>
//引入fullpage
import "../../assets/libs/fullpage/jquery.fullPage.css"
import "../../assets/libs/fullpage/jquery.fullPage.min.js"
import "../../assets/css/style.css"
    export default{
        data(){
            return {
                platform: 1   //1 pc端   2 mobile端
            }
        },
        mounted(){
            if($(window).width() > 786){
                this.platform = 1;
                var $mlNav = $('.product_menu');
                $('#product').fullpage({
                    verticalCentered: !1,
                    navigation: !0,
                    anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10'],
                    menu: '#product_menu',
                    onLeave: function(index, nextIndex, direction){
                        if(index == 2 && direction == 'up'){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        } else if(index == 1 && direction == 'down') {
                            $mlNav.animate({
                                top: 0
                            }, 500);
                            $(".headmenu_two").hide();
                        }
                        if(nextIndex == 1){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        }
                        if(nextIndex == 10){
                            $mlNav.hide();
                        }else{
                            $mlNav.show();
                        }
                    },
                    afterLoad: function(anchorLink, index){
                        //$(".product_li").css("height", $("#product").height());
                         if(index == 3 || index == 4 || index == 6){
                            $(".product_menu dt a").css("color","#9e9e9f");
                            $(".product_menu dd a").css("color","#9e9e9f");
                            $(".product_menu dd.active a").css("color","#000000");
                            $(".product_menu dt a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dd a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dt a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                        }else{
                            $(".product_menu dt a").css("color","#9e9e9f");
                            $(".product_menu dd a").css("color","#9e9e9f");
                            $(".product_menu dd.active a").css("color","#ffffff");
                            $(".product_menu dt a").mouseover(function(){
                                $(this).css("color","#ffffff");
                            });
                            $(".product_menu dd a").mouseover(function(){
                                $(this).css("color","#ffffff");
                            });
                            $(".product_menu dt a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            
                        }

                        /*回到顶部*/
                        if(index == 1 || index == 2){
                            $(".gotoTop").hide();
                        }else{
                            $(".gotoTop").show();
                        }
                    }
                })
            }else{
                this.platform = 2;
            }
        },
        destroyed(){
            var html = document.querySelector("html");
            var width = html.getBoundingClientRect().width;
            //设置 1rem = width/16
            if(width >= 768){
                //去除fullpage插件设置的100%高度和隐藏溢出
                $("html, body").removeAttr("style");
                $("html, body").removeAttr("class");
            }
        }
    }
</script>
<style scoped>
@media (min-width: 768px){
    .header-wrap{
        position: relative !important;
    }
}
    

    
</style>


// WEBPACK FOOTER //
// src/pages/products/b0.vue